import BaseFirebaseStore from './BaseFirebaseStore.js'

/**
 * @class Returns a new DeviceStore class that is used to access the various bins of a Device's information
 **/
export default class DeviceStore extends BaseFirebaseStore {

  /**
   * @function data returns an instance of access for getting data
   */
  data() {
    if ( this._dataAccess == null ) {
      this._dataAccess = super.access( 'data' )
    }
    return this._dataAccess
  }

  /**
   * @function meta returns an instance of access for getting the meta
   */
  meta() {
    if ( this._metaAccess == null ) {
      this._metaAccess = super.access( 'meta' )
    }
    return this._metaAccess
  }

  /**
   * @function events returns an instance of access for getting events
   */
  events() {
    if ( this._eventAccess == null ) {
      this._eventAccess = super.access( 'events' )
    }
    return this._eventAccess
  }

  /**
   * @function outbound returns an instance of access for outbound data
   */
  outbound() {
    if ( this._outboundAccess == null ) {
      this._outboundAccess = super.access( 'outbound' )
    }
    return this._outboundAccess
  }

  /**
   * @function device returns an instance of access for devices
   */
  device() {
    if ( this._deviceAccess == null ) {
      this._deviceAccess = super.access( 'device' )
    }
    return this._deviceAccess
  }

  /**
   * @function cache returns an instance of access for the cache
   */
  cache() {
    if ( this._deviceAccess == null ) {
      this._cacheAccess = super.access( 'cache' )
    }
    return this._cacheAccess
  }
}
